import React, { Component } from 'react';
import { Card, CardBody, CardTitle, Button, Row, Col, Input, CardHeader } from 'reactstrap';
// eslint-disable-next-line
function renderIf(condition, trueComponent, falseComponent) {
	if (condition === true) {
		return trueComponent;
	} else {
		return falseComponent;
	}
}

export default class AddUser extends Component {
	constructor(props) {
		super(props);
		this.state = {
			Cpalink: '',
			contador: '',
			Back: '',
		};
	}
	getSessionData(params) {
		return window.sessionStorage.getItem(params);
	}

	componentDidMount() {}
	handleCPA(event) {
		this.setState({ Cpalink: event.target.value });
	}
	handlecontador(event) {
		this.setState({ contador: event.target.value });
	}
	handleBack(event) {
		this.setState({ Back: event.target.value });
	}

	changeCPA() {
		let that = this;
		(async function () {
			let req = await fetch(
				`${process.env.REACT_APP_BACKEND_URL}/team/changecpa?link=${encodeURIComponent(that.state.Cpalink)}&token=${that.getSessionData(
					'UToken'
				)}`,
				{
					headers: {
						accept: '**',
						'accept-language': 'es-ES,es;q=0.9,en;q=0.8',
						authorization: 'BEARER ' + that.getSessionData('VToken'),
					},
					method: 'GET',
				}
			);
			let response = await req.json();
			if (response.ok === true) {
				alert('sucess');
			} else {
				alert('hubo un error chamo');
			}
		})();
	}
	changeBack() {
		let that = this;
		(async function () {
			let req = await fetch(
				`${process.env.REACT_APP_BACKEND_URL}/team/changeback?link=${encodeURIComponent(that.state.Back)}&token=${that.getSessionData(
					'UToken'
				)}`,
				{
					headers: {
						accept: '*/*',
						'accept-language': 'es-ES,es;q=0.9,en;q=0.8',
						authorization: 'BEARER ' + that.getSessionData('VToken'),
					},
					method: 'GET',
				}
			);
			let response = await req.json();
			if (response.ok === true) {
				alert('sucess');
			} else {
				alert('hubo un error chamo');
			}
		})();
	}

	changeCounter() {
		let that = this;

		(async function () {
			let req = await fetch(
				`${process.env.REACT_APP_BACKEND_URL}/team/changecounter?contador=${encodeURIComponent(
					that.state.contador
				)}&token=${that.getSessionData('UToken')}`,
				{
					headers: {
						accept: '*/*',
						'accept-language': 'es-ES,es;q=0.9,en;q=0.8',
						authorization: 'BEARER ' + that.getSessionData('VToken'),
					},
					method: 'GET',
				}
			);
			let response = await req.json();
			if (response.ok === true) {
				alert('sucess');
			} else {
				alert('hubo un error chamo');
			}
		})();
	}
	render() {
		return (
			<div className='content'>
				{renderIf(
					this.getSessionData('typeofuser') === 'admin',
					<>
						<Row>
							<Col lg='6' md='12'>
								<Card>
									<CardBody>
										<CardHeader>
											<CardTitle tag='h4'>Link de CPA del equipo</CardTitle>
										</CardHeader>
										<Input onChange={this.handleCPA.bind(this)} type='text' style={{ marginBottom: '1rem' }}></Input>

										<Button
											color='info'
											className='animation-on-hover'
											onClick={() => {
												this.changeCPA();
											}}
										>
											Cambiar
										</Button>
									</CardBody>
								</Card>
							</Col>
							<Col lg='6' md='12'>
								<Card>
									<CardBody>
										<CardHeader>
											<CardTitle tag='h4'>Contador del equipo</CardTitle>
										</CardHeader>
										<Input onChange={this.handlecontador.bind(this)} type='text' style={{ marginBottom: '1rem' }}></Input>

										<Button
											color='info'
											className='animation-on-hover'
											onClick={() => {
												this.changeCounter();
											}}
										>
											Cambiar
										</Button>
									</CardBody>
								</Card>
							</Col>
						</Row>
						<Row>
							<Col lg='6' md='12'>
								<Card>
									<CardBody>
										<CardHeader>
											<CardTitle tag='h4'>Link de patra del equipo</CardTitle>
										</CardHeader>
										<Input onChange={this.handleBack.bind(this)} type='text' style={{ marginBottom: '1rem' }}></Input>

										<Button
											color='info'
											className='animation-on-hover'
											onClick={() => {
												this.changeBack();
											}}
										>
											Cambiar
										</Button>
									</CardBody>
								</Card>
							</Col>
						</Row>
					</>
				)}
			</div>
		);
	}
}
